import * as tslib_1 from "tslib";
import { ServiceUnavailablePlaceholder, SpinnerSvg } from '@nextiva/next-ui';
import React from 'react';
import { apiDebugLogin } from './dataProvider';

var SignInDecorator =
/** @class */
function (_super) {
  tslib_1.__extends(SignInDecorator, _super);

  function SignInDecorator() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      statusCode: null,
      isLoading: true
    };
    return _this;
  }

  SignInDecorator.prototype.componentDidMount = function () {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      var statusCode;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , apiDebugLogin()];

          case 1:
            statusCode = _a.sent();
            this.setState({
              statusCode: statusCode,
              isLoading: false
            });
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  SignInDecorator.prototype.render = function () {
    var _a = this.state,
        isLoading = _a.isLoading,
        statusCode = _a.statusCode;

    if (isLoading) {
      return React.createElement(SpinnerSvg, {
        size: 30
      });
    }

    if (statusCode === 200) {
      return this.props.children();
    } else {
      return React.createElement(ServiceUnavailablePlaceholder, null);
    }
  };

  return SignInDecorator;
}(React.PureComponent);

export default SignInDecorator;